
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconArrowCircleRight = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm4.961 13.358l-7.346 5.634a1.25 1.25 0 11-1.521-1.984l6.271-4.81a.249.249 0 000-.4L8.094 6.992a1.25 1.25 0 111.521-1.984l7.346 5.634a1.711 1.711 0 010 2.716z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-23C5.935 1 1 5.935 1 12s4.935 11 11 11 11-4.935 11-11S18.065 1 12 1z' }),
    React.createElement('path', { d: 'M8.5 19a.499.499 0 01-.496-.567.499.499 0 01.192-.331l7.994-6.1-7.993-6.105a.499.499 0 11.606-.794l7.994 6.105a.995.995 0 01.384.928.997.997 0 01-.385.662l-7.993 6.1A.498.498 0 018.5 19z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-22.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5z' }),
    React.createElement('path', { d: 'M9 18a.747.747 0 01-.732-.913.742.742 0 01.33-.47L15.853 12 8.597 7.383a.75.75 0 11.805-1.266l7.257 4.617a1.494 1.494 0 01.659 1.59 1.49 1.49 0 01-.658.942l-7.257 4.617A.754.754 0 019 18z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowCircleRight.displayName = 'IconArrowCircleRight';
export default IconArrowCircleRight;